<template>
    <vue-apex-charts
        type="area"
        height="200"
        :options="options.chartOptions"
        :series="options.series"
    />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

export default {
    components:{
        VueApexCharts,
    },
    props:{
        data:Array,
    },
    computed:{
        options(){
            return {
                series: [
                    {
                        data: this.data.map(d=>Number(d.rate.replace(",","."))),
                    },
                ],
                chartOptions: {
                    chart: {
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                        },
                    },
                    markers: {
                        strokeWidth: 7,
                        strokeOpacity: 1,
                        strokeColors: [$themeColors.light],
                        colors: [$themeColors.success],
                    },
                    colors: [$themeColors.success],
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        width:2,
                        curve: 'straight',
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true,
                            },
                        },
                    },
                    tooltip: {
                        custom(data) {
                        return `
                        ${'<div class="px-1 py-50"><span>'}${
                            data.series[data.seriesIndex][data.dataPointIndex]
                        }</span></div>`
                        },
                    },
                    xaxis: {
                        categories: this.data.map(d=>d.date),
                    },
                    yaxis: {},
                },
            }
        }
    }
}
</script>

<style>

</style>